import { create } from 'zustand';
import type { Invoice } from 'contracts/tracking-v2/invoices';

type State = {
  invoice?: Invoice,
}

type Actions = {
  setInvoice: (invoice: Invoice) => void,
  resetInvoiceStoreState: () => void,
}

const getInitialState = (): State => ({
  invoice: undefined,
});

export const useInvoiceStore = create<State & Actions>(
  (set) => ({
    ...getInitialState(),
    setInvoice: (invoice) => set({ invoice }),
    resetInvoiceStoreState: () => set(getInitialState()),
  }),
);